import React from 'react';
import { Grid } from 'semantic-ui-react';
import QueryDictionariesHeader from '../queries/containers/QueryDictionariesHeader';
import CohortBuildingGrid from './CohortBuildingGrid';
import CohortVisualisationsGrid from '../visualisations/components/CohortVisualisationsGrid';

const CohortInfoGrid = ({
  code,
  category,
  isNew,
  queryAccess,
  queryUUID,
  allowCohortVisualisations,
  expandedCharts,
}) => (
  <Grid>
    {queryUUID && isNew && (
    <Grid.Row>
      <Grid.Column>
        <QueryDictionariesHeader code={code} category={category} queryUUID={queryUUID} as="h2" />
      </Grid.Column>
    </Grid.Row>
    )}
    <Grid.Row columns="equal">
      {!expandedCharts
      && (
      <Grid.Column>
        <CohortBuildingGrid
          code={code}
          category={category}
          isNew={isNew}
          queryAccess={queryAccess}
          queryUUID={queryUUID}
        />
      </Grid.Column>
      )}
      <Grid.Column>
        <CohortVisualisationsGrid
          code={code}
          category={category}
          queryAccess={queryAccess}
          allowCohortVisualisations={allowCohortVisualisations}
          isNew={isNew}
        />
      </Grid.Column>
    </Grid.Row>
  </Grid>
);

export default CohortInfoGrid;
